import styles from "./index.module.css";
import { useEffect, useRef } from "react";
import BuyCard from "../../buyCard";
import VideoAlert from "../../../video-alert";
import PreAndNext from "../../preAndNext";
import Cast from "../../cast";
import LazyLoad from "react-lazyload";
const TheMatchDetail = ({
  isMobile,
  handleNextIndex,
  handleLastIndex,
  playVideo,
  pauseVideo,
  movieData,
}) => {
  useEffect(() => {
    new VideoAlert(
      {
        havePathElement: `.${styles.btsPlayButton}`,
        openAlert: pauseVideo,
      },
      []
    );
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.movieInfo}>
        <div className={styles.movieNameBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-1.jpg"
            alt=""
            className={styles.movieName}
          />
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-2.jpg"
            alt=""
            className={styles.btsPlayButton}
            data-cursor-size="80px"
            data-video-src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-bts-05.mp4"
          />
        </div>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-3${
            isMobile ? "-m" : ""
          }.jpg`}
          alt=""
          className={styles.author}
        />
      </div>
      <div className={styles.sec1}>
        <img
          src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-4.png"
          alt=""
        />

        <img
          src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-5.jpg"
          alt=""
        />

        <div className={styles.textBox}>
          <div>
            <h2>It’s All About</h2>
            <h1>Adrenaline.</h1>
          </div>

          <h5>
            The match we see on screen is a projection of the boxers’ mind
            during training. This short film could best represent the adrenaline
            charge and concentration during a preparation for a fight. Most of
            the energy was used for the coordination of the boxers and stuntmen,
            as well as the movement of the camera.
          </h5>
        </div>
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-7.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-7-cover.jpg"
            className={styles.abMedia1}
          ></video>
        </LazyLoad>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-8.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-8-cover.jpg"
            className={styles.abMedia2}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-6${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>
      <div className={styles.sec2}>
        <div className={styles.imgBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-9.png"
            alt=""
          />
          <LazyLoad offset={300}>
            <video
              autoPlay
              loop
              playsInline
              muted
              preload="true"
              src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-10.mp4"
              poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-10-cover.jpg"
              className={styles.abMedia3}
            ></video>
          </LazyLoad>
        </div>
        <div className={styles.textBox}>
          <h2>Keep The Continuity.</h2>
          <h5>
            When making the short film, the camera is rendered as less invasive
            as possible, favoring the continuity of the action through long
            shots and soft transitions. In this case, the smartphone gimbal is
            the best supportive match for this goal, while maintaining a dynamic
            language.
          </h5>
        </div>
      </div>

      <div className={styles.sec3}>
        <div className={styles.textBox}>
          <h2>Full Expressive Freedom.</h2>
          <h5>
            When using different modalities in the smartphone gimbal, we can
            switch from the simulation of slow dollies or small sliders,
            interfacing the gimbal with other accessories, to the possibility of
            freely moving across all axes, swinging the camera around the boxers
            and maintaining full expressive freedom, which was fundamental in
            this short film.
          </h5>
        </div>
        <div className={styles.imgBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-11.png"
            alt=""
          />
          <LazyLoad offset={300}>
            <video
              autoPlay
              loop
              playsInline
              muted
              preload="true"
              src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-12.mp4"
              poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-5-12-cover.jpg"
              className={styles.abMedia4}
            ></video>
          </LazyLoad>
        </div>
      </div>
      <Cast
        movieName={movieData.name}
        data={[
          {
            post: "DIRECTOR/DIRECTOR OF PHOTOGRAPHY",
            name: "VINCENZO DE CARO",
          },
          {
            post: "CO-DIRECTOR",
            name: "MARCO SCUOTTO",
          },
          {
            post: "STARRING",
            name: "FLAVIO ALTISSIMI, SAMUELE OLIVIERI",
          },
          {
            post: "STUNT COORDINATOR",
            name: "DAVID ZAMPERLA",
          },
          {
            post: "SOUND DESIGNER",
            name: "MARCO CONTE",
          },
          {
            post: "MAKE-UP ARTIST",
            name: "FRANCESCA FACCENDA",
          },
          {
            post: "BACKSTAGE VIDEO",
            name: "DAVIDE MARCHIONE",
          },
          {
            post: "BACKSTAGE PHOTO",
            name: "NOEMI GENTILUOMO",
          },
          {
            post: "SPECIAL THANKS",
            name: "ANDREA BARBERIS, DAVIDE POLIDORI, ALESSIA CAMPO, GABRIELE SERAFINI, MARTINA DE VIVO, ANDREA GABRIELE",
          },
        ]}
      />
    </div>
  );
};

export default TheMatchDetail;
